import { render, staticRenderFns } from "./miorecord.vue?vue&type=template&id=13475d21&"
import script from "./miorecord.vue?vue&type=script&lang=ts&"
export * from "./miorecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports